import React, { useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  getUser,
  isLoggedIn,
  logout,
} from "../../../../controller/reducer/user";
import LogoutModal from "../logout";
import "./styles.css";

function Header() {
  const loggedIn = useSelector(isLoggedIn);
  const user = useSelector(getUser);
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const logoutTask = () => {
    history.push("/admin");
    dispatch(logout());
  };

  return (
    <Navbar expand="md" bg="dark" variant="dark">
      <Navbar.Brand href="/admin">Covid Resources</Navbar.Brand>
      {loggedIn && <Navbar.Toggle aria-controls="responsive-navbar-nav" />}
      {loggedIn && (
        <Navbar.Collapse id="responsive-navbar-nav justify-content-between">
          <Nav className="mr-auto">
            <Nav.Link as={Link} to="/admin/">
              Location Resources
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/remedies">
              Home Therapy
            </Nav.Link>
            <Nav.Link as={Link} to="/admin/key-resources">
              Important Links
            </Nav.Link>
            {( user.type === "root"|| user.type === "super" )&& (
              <Nav.Link as={Link} to="/admin/user">
                User
              </Nav.Link>
            )}
            {/* <Nav.Link as={Link} to="/admin/stories">Stories</Nav.Link>
        <Nav.Link as={Link} to="/admin/about">About</Nav.Link> */}
          </Nav>
          <Nav.Link
            onClick={() => setShow(true)}
            className="ml-auto text-light"
          >
            {user.name ? user.name.split(" ")[0] : ""}
          </Nav.Link>
        </Navbar.Collapse>
      )}
      {loggedIn && show && (
        <LogoutModal
          onClose={() => setShow(false)}
          user={user}
          logout={logoutTask}
        />
      )}
    </Navbar>
  );
}

export default Header;
